<template lang="pug">
header.v-page-header.page-header
	.container
		.page-header__layout
			.page-header__cell.page-header__cell--menu(v-if="menu" )
				button.page-header__menu-btn(v-if="menu.button" :type="menu.button?.type" @click="openMobileNav", :aria-label="menu.button?.ariaLabel")
					v-svg-icon.page-header__menu-icon(:icon="menu.button?.icon")
				.page-header__logo-block(v-if="menu.logo" )
					a.page-header__logo-link(v-if="menu.logo.href" :href="menu.logo.href")
						v-svg-icon.page-header__logo-icon(:icon="menu.logo.icon")
				.page-header__cells
					.top-nav__cell(v-for="(item, index) in menu.items" :key="index")
						a.top-nav-link(:href="item.lkTrigger ? null : item.link"
							:data-modal-url="item.modalLink"
							:data-modal-data="item.modalData"
							:class="[item.className, {'js-open-modal': item.modalLink || item.modalData, 'top-nav-link--lk': item.lkTrigger}]"
							@mouseenter="mouseenter(item)"
							@mouseleave="mouseleave(item)"
							@mousemove="mousemove(item)"
							@click="itemClick(item, $event)")
							img.top-nav-link__img(v-if="item.image && item.image.src" :src="item.image.src" :alt="item.image.alt")
							v-svg-icon.top-nav-link__icon(v-else-if="item.icon" :icon="item.icon")
							.top-nav-link__main(v-if="item.text") {{item.text}}
						.top-nav__dd(
							v-if="item.items && item.items.length"
							:class="{'top-nav__dd--open': openMenuId === item.menuId}"
							@mouseenter="mouseenter(item)"
							@mouseleave="mouseleave(item)")
							ul.top-nav__dd-list
								li.top-nav__dd-item.flc(v-for="(itemL2, itemL2Index) in item.items" :key="itemL2Index")
									a.top-nav__dd-link(:href="itemL2.link") {{itemL2.text}}

			template(v-if="$slots['top-nav']" )
				.page-header__cell.page-header__cell--top-nav
					slot(name="top-nav")
			template(v-if="$slots['main-nav']" )
				.page-header__cell.page-header__cell--main-nav
					slot(name="main-nav")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from '../scripts/controller/controller.js';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			menu: {},
			openMenuId: null,
			openTimeout: null,
			closeTimeout: null,
			touch: controller.touch
		};
	},

	created() {
		document.addEventListener('click', this.handleClickOutside);
		document.addEventListener('keydown', this.handleEsc);
	},

	unmounted() {
		document.removeEventListener('click', this.handleClickOutside);
		document.removeEventListener('keydown', this.handleEsc);
	},

	methods: {
		dataSet(data) {
			this.menu = data;
		},

		openMobileNav() {
			controller.openMobileNav();
		},

		mouseenter(item) {
			if (this.touch) {
				return;
			}
			if (this.openMenuId === item.menuId) {
				clearTimeout(this.closeTimeout);
			}
		},

		mouseleave() {
			if (this.touch) {
				return;
			}
			clearTimeout(this.openTimeout);
			this.closeTimeout = setTimeout(() => {
				this.openMenuId = null;
			}, 300);
		},

		mousemove(item) {
			if (this.touch) {
				return;
			}
			clearTimeout(this.openTimeout);
			if (item.items && item.items.length) {
				this.openTimeout = setTimeout(() => {
					clearTimeout(this.closeTimeout);
					this.openMenuId = item.menuId;
				}, 40);
			}
		},

		itemClick(item, e) {
			// Клик по фото/ID пользователя (мобильная шапка) — переключаем
			// пользовательскую шторку ЛК вместо перехода по ссылке.
			if (item.lkTrigger) {
				e.preventDefault();
				controller.toggleLkMobileMenu();
				return;
			}
			if (!this.touch) {
				return;
			}
			if (this.openMenuId !== item.menuId && item.items && item.items.length) {
				e.preventDefault();
				this.openMenuId = item.menuId;
			} else {
				this.openMenuId = null;
			}
		},

		handleClickOutside(e) {
			if (!this.$el.contains(e.target)) {
				this.openMenuId = null;
			}
		},

		handleEsc(e) {
			if (e.keyCode === 27 && this.openMenuId) {
				e.stopPropagation();
				this.openMenuId = null;
			}
		}
	}
};
</script>
